import React, { Component } from "react";

const const1 = 'const1';

class FakeSession extends Component {
  
/*const const2 = 'const2';*/
test(){
	return 324;
};
  
  render() {
  
  const const3 = 'const3';

  
    return (
	<>
	"fruit":"apple";
	,"veg":"carrot"
	</>
    );
  };
}

export default FakeSession;
